// extracted by mini-css-extract-plugin
export default {"loadingIndicator":"documents__style__loadingIndicator___pA53h","spin":"documents__style__spin___XIaM+","isDark":"documents__style__isDark___L3mSM"};